let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dSwYG")).then(() => parcelRequire('2oHRg'));